import React from 'react';

const HyperlinkContainer = props => {
  const { getAllClasses, element } = props;
  const { type = 'default' } = element.data || {};

  const { formItemSettings, formSettings } = element.data || {};
  const { text, fontSize, disabled, url } = formItemSettings;

  const hyperlinkStyle = disabled ? {
    fontSize: `${fontSize}px`,
    pointerEvents: 'none',
  } : {
      fontSize: `${fontSize}px`,
    }

  return (
    <div
      className={getAllClasses(
        'webiny-pb-page-element-button',
        'webiny-pb-page-element-button--' + type
      )}
      {...formSettings}
    >
      <a href={url} style={{ ...hyperlinkStyle }}>{text}</a>
    </div>
  );
};

export default HyperlinkContainer;
